export const QUIZ = 'QUIZ_QUIZ'
export const ANSWER = 'QUIZ_ANSWER'
export const ACTIVE_QUESTION = 'QUIZ_ACTIVE_QUESTION'
export const RESET_QUIZ = 'QUIZ_RESET_QUIZ'
export const SUBMIT_QUIZ = 'SUBMIT_QUIZ'
export const ON_END_COUNT = 'ON_END_COUNT'
export const SET_QUIZ_TIMER = 'SET_QUIZ_TIMER'
export const SET_CLOSE_QUIZ_OVERLAY = 'SET_CLOSE_QUIZ_OVERLAY'
export const SET_GRADED_QUESTIONS = 'SET_GRADED_QUESTIONS'
